import { TabulationDatum } from '@mtna/rds-base-ui';

export class DatumCell {
  /**
   * @param datumStack Ordered datum related to a table column/row (parents and current child).
   * @param subtotal Whether the column is a subtotal
   * @param id Generated identifier for use with mat-table column defs.
   * @param cellspan optional number of cells to span
   */
  constructor(public datumStack: Array<TabulationDatum<any>>, public subtotal: boolean, public id: string, public cellspan: number = 1) {}
}

/**
 * Represents a DatumCell within a mat-table row
 */
export class RowDatumCell {
  /**
   *
   * @param datum Datum for this cell
   * @param rowspan number of table rows to span
   * @param first first row using this Datum
   */
  constructor(public datum: TabulationDatum<any>, public rowspan: number, public first = false) {}
}
